import { useState } from 'react';

function Numpad({ onSubmit, initialValue = '', buttonLabel = 'Submit' }) {
  const [value, setValue] = useState(initialValue);

  const handleButtonClick = (digit) => {
    if (digit === 'clear') {
      setValue('');
    } else if (digit === 'backspace') {
      setValue(prev => prev.slice(0, -1));
    } else if (digit === '.') {
      if (!value.includes('.')) {
        setValue(prev => prev + '.');
      }
    } else {
      setValue(prev => prev + digit);
    }
  };

  const handleSubmit = () => {
    const numValue = parseFloat(value) || 0;
    onSubmit(numValue);
  };

  return (
    <div className="w-full">
      <div className="p-2 bg-gray-50 border rounded-md mb-4">
        <input
          type="text"
          className="w-full text-right text-2xl font-bold py-2 px-3 bg-white border rounded-md"
          value={value}
          readOnly
        />
      </div>

      <div className="grid grid-cols-3 gap-2">
        {[7, 8, 9, 4, 5, 6, 1, 2, 3].map(digit => (
          <button
            key={digit}
            className="border border-gray-300 rounded-md py-4 font-bold text-xl transition-colors"
            
            onClick={() => handleButtonClick(digit.toString())}
          >
            {digit}
          </button>
        ))}
        
        <button
          className="border border-gray-300 rounded-md py-4 font-bold text-xl transition-colors"
          
          onClick={() => handleButtonClick('.')}
        >
          .
        </button>
        
        <button
          className="border border-gray-300 rounded-md py-4 font-bold text-xl transition-colors"
       
          onClick={() => handleButtonClick('0')}
        >
          0
        </button>
        
        <button
          className="border border-gray-300 rounded-md py-4 transition-colors flex justify-center items-center"
        
          onClick={() => handleButtonClick('backspace')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
          </svg>
        </button>
      </div>
      
      <div className="grid grid-cols-2 gap-2 mt-2">
        <button
          className="border rounded-md py-3 font-medium transition-colors"
          style={{ backgroundColor: '#fdf54d', color: 'black', borderColor: '#fdf54d' }}
          onClick={() => handleButtonClick('clear')}
        >
          Effacer
        </button>
        
        <button
          className="border rounded-md py-3 font-medium transition-colors"
          style={{ backgroundColor: '#56adb2', color: 'white', borderColor: '#56adb2' }}
          onClick={handleSubmit}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#4a99a5';
            e.currentTarget.style.borderColor = '#4a99a5';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#56adb2';
            e.currentTarget.style.borderColor = '#56adb2';
          }}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}

export default Numpad;
